import styled from "styled-components";
import { Colors } from "../config";

export const ToastMessage = ({ message }) => {
  return (
    <>
      <StyledMessage>{message}</StyledMessage>
    </>
  );
};

const StyledMessage = styled.p`
  font-weight: 500;
  font-style: normal;
  font-size: 14px;
  color: ${Colors.black};
  margin: 0;
`;

const StyledSubMessage = styled.p`
  color: #acacac;
  margin: 0;
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  padding-top: 2px;
`;
